import APIRequest from './APIRequest.js';

export const GetNavigation = (global) => {
    return APIRequest({
        global: global,
        url: 'Navigation/GetNavigation',
        method: 'get'
    })
}